import { render, staticRenderFns } from "./deviceTip.vue?vue&type=template&id=f0ced1cc&scoped=true&"
import script from "./deviceTip.vue?vue&type=script&lang=js&"
export * from "./deviceTip.vue?vue&type=script&lang=js&"
import style0 from "./deviceTip.vue?vue&type=style&index=0&id=f0ced1cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ced1cc",
  null
  
)

export default component.exports